// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"rec-create_paragraph__3e0Hi","btn":"rec-create_btn__2WbvJ","borderContainer":"rec-create_borderContainer__2dEJs"};